import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useParams  } from "react-router-dom";
import Icon from "../Icon";
import Header from "../main/Header";
import MobilMenu from "../mobil-menu/MobilMenu";
import Charts from "./Charts";
import configToJson from "./Config";
import Links from "./Links";
import Modszer from "./Modszer";
import { FormattedMessage } from 'react-intl';

const Publi = ({ main, toogleMode, mode }) => {
    let { name } = useParams();

    const [settings, setSettings] = useState(false);
    const [theme, setTheme] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedChart, setSelectedChart] = useState(false);
    const [selectedLinks, setSelectedLinks] = useState(null);

    useEffect(() => {
        if (main.sections) {
            const findedTheme = main.sections.find(m => m.url === settings.type);
            if (findedTheme) {
                setTheme(findedTheme);
            }
        }
    }, [main, settings])

    /* eslint-disable */
    useEffect(() => {
        const ownLinks = selectedChart && selectedChart.links && selectedChart.links.length > 0 ? selectedChart.links : [];
        const inheritedLinks = settings && settings.publilinks && settings.publilinks.length > 0 ? settings.publilinks : [];
        const selectedLinks = [...ownLinks, ...inheritedLinks];
        setSelectedLinks(selectedLinks.length ? selectedLinks : null);

        const productItemId = selectedChart.guid;
        const productInfo = `${(theme && theme.title) || ""} - ${(selectedChart && selectedChart.order) || ""}. ${(selectedChart && selectedChart.title) || ""} - ${window.location.href}`
        window.feedback.productItemId = productItemId;
        window.feedback.productInfo = productInfo;
    }, [selectedChart])

    //Az adott konfiguráció betöltéses
    useEffect(() => {
        const fetchSettings = async () => {
            try {
            const settingsRequest = await fetch(`${window.PUBLICATION_DATA_URL}kiadvanyok/${name}.json`);
            let settingsObject = await settingsRequest.json();
            settingsObject.chartlist = configToJson(settingsObject.chartlist);
            setSettings(settingsObject);
            setLoading(false);
            }
            catch(e) {
                console.log(e)
                window.location.href = "./";
            }
        }
        fetchSettings();
    }, [name, mode]);


    return (<><div className={theme ? theme.url : "notheme"}>{!loading && <>
        {theme && <Header theme={theme} toogleMode={toogleMode} mode={mode} />}
        <Container fluid className="content-container">
            <Row className="justify-content-md-center g-0">
                <Col lg={10} md={12} className="chart-data-container">
                    <Charts theme={theme} publication={settings } selectedChart={selectedChart} setSelectedChart={setSelectedChart} mode={mode} />
                </Col>
                {(!selectedChart||!selectedChart.modszer)&&settings&&settings.modszertan&&<Col className="modszertan-container" lg={10} xs={12}><Modszer mode={mode}  theme={theme} publication={settings } modszer={settings.modszertan || ""} /></Col>}
                {selectedChart&&selectedChart.modszer&&<Col className="modszertan-container" lg={10} md={12}><Modszer  theme={theme} publication={settings }  mode={mode} modszer={selectedChart.modszer || ""} /></Col>}
                {selectedChart && selectedLinks&&<Col className="chart-links-container" lg={10} md={12}>
                    <Links linkList={selectedLinks} linkTypes={main.linktypes} mode={mode} />
                </Col>}
            </Row>
        </Container>
    </>}
    </div>
    <div className={"feedback-button " + (theme ? theme.url : "notheme")}><button class="button" onClick={() => window.feedback.show()}><Icon icon={"feedback"} className={"white"} /><FormattedMessage id="feedback" defaultMessage="Visszajelzés" /></button></div>
    <MobilMenu mode={mode} toogleMode={toogleMode} />
    </>)
}

export default Publi;
